import { useRef, useState, useEffect } from "react";
import ReactPlayer from "react-player";
import mainLogo from "../../assets/customerAssets/logoWB.png";

const Video = ({ link, thumbnail }) => {
  const videoRef = useRef(null);

  const containerRef = useRef(null);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null, // viewport
        threshold: 0.1, // 50% visible
      },
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="video-div" ref={containerRef}>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            background: "#000",
          }}
        >
          <div className="video-water-mark">
            <img
              src={mainLogo}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>

          {/* {!isVisible && (
            <img
              src={thumbnail}
              alt="video thumbnail"
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )} */}

          {/* {isVisible && ( */}
          <ReactPlayer
            url={link}
            width="100%"
            height="100%"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              objectFit: "cover",
            }}
            controls={true}
            ref={videoRef}
            // light={thumbnail}
            //   light={true}
          />
          {/* )} */}
        </div>
      </div>
    </>
  );
};

export default Video;
